import config from "@frameworks/salesjourney/config/domain";
import { microService } from "../SalesJourney/microServiceBase";
var aifPms = "AifPms/";
var masterService = microService.masterSevice;
var investmentService = microService.investmentService;
var leadServiceApi = microService.leadService;
var qc = "Qc/";
var v3 = "v3/";
var AifPmsConfigURL = {
    getAifPmsWatchList: config.investmentJourneyBaseUrl +
        masterService +
        //"v2/" +
        aifPms +
        "WatchList",
    getProductDetails: config.investmentJourneyBaseUrl +
        masterService +
        //"v2/" +
        aifPms +
        "productdetails",
    getFilterDetails: config.investmentJourneyBaseUrl +
        masterService +
        //"v2/" +
        aifPms +
        "productfilters",
    getValidateForm: config.investmentJourneyBaseUrl + masterService + aifPms + "validateform",
    getDownloadData: config.investmentJourneyBaseUrl + masterService + "downloaddata",
    bookmark: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Bookmark/" +
        "bookmark",
    bookmarkWatchlist: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Bookmark/" +
        "bookmarkwatchlist",
    downloadProductFile: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Bookmark/" +
        "downloadproductfile",
    multibookmark: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Bookmark/" +
        "multibookmark",
    commonBankMaster: config.investmentJourneyBaseUrl + masterService + "v1/Common/bankmaster",
};
export var AifPmsDraftUrl = {
    saveDraftOrders: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/AifPmsDraft/" +
        "savedraftorders",
    draftOrderCount: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "draftordercount",
    getDraftOrders: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "getdraftorders",
    draftOrderDetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "draftorderdetails",
    draftOrderUpdate: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "draftorderupdate",
    deletedDraftOrder: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "deletedraftdocs",
    previewDocs: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "previewdocs",
    saveDraftDocs: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/AifPmsDraft/" +
        "savedraftdocs",
    draftOrderDeclaration: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPmsDraft/" +
        "draftorderdeclarations",
};
export var AifPmsPurchaseUrl = {
    orders: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/Purchase/" +
        "orders",
    orderList: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/Purchase/" +
        "orderlist",
    emppartnerdetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Purchase/" +
        "emppartnerdetails",
    docs: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Purchase/" +
        "docs",
    orderDetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/Purchase/" +
        "orderdetails",
    validateForm: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Purchase/" +
        "validateform",
    orderdeclarations: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Purchase/" +
        "orderdeclarations",
    multidocs: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/Purchase/" +
        "multidocs",
};
export var AifPmsGlobalUrl = {
    recentClientSearchGet: config.investmentJourneyBaseUrl +
        masterService +
        "v1/Common/" +
        "recentclientsearchget",
    recentClientSearchSave: config.investmentJourneyBaseUrl +
        masterService +
        "v1/Common/" +
        "recentclientsearchsave",
    trxTypeList: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Global/" +
        "trxtypelist",
    userPopupStatus: config.investmentJourneyBaseUrl +
        masterService +
        "v1/Common/" +
        "userpopupstatus",
    userPopupStatusSave: config.investmentJourneyBaseUrl +
        masterService +
        "v1/Common/" +
        "userpopupstatussave",
    validateclient: config.investmentJourneyBaseUrl +
        masterService +
        "v1/Common/" +
        "validateclient",
    holdingsummary: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Global/" +
        "holdingsummary",
    foliodetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Global/" +
        "foliodetails",
    holdingqtydetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Global/" +
        "holdingqtydetails",
    aggregatedholding: config.investmentJourneyBaseUrl +
        investmentService +
        "v2/Global/" +
        "aggregatedholding",
    uccclient: config.investmentJourneyBaseUrl + masterService + "ElasticSearch/uccclient",
    uccCodeclient: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/Global/" +
        "clientuccdetails",
};
export var AifPmsOrderBookUrl = {
    orderbooklist: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPms/" +
        "orderbooklist",
    orderbookDownload: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPms/" +
        "DownloadOrderbook",
    updateleadorderbook: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPms/" +
        "updateleadorderbook",
    orderbookdetails: config.investmentJourneyBaseUrl +
        investmentService +
        "v1/AifPms/" +
        "orderbookdetails",
};
export var AifPmsLeadServiceUrl = {
    partnerlead: config.investmentJourneyBaseUrl +
        leadServiceApi +
        "ExternalLeads/PartnerLead",
    sbSearch: config.investmentJourneyBaseUrl + leadServiceApi + "masters/SB",
    leadSearch: config.investmentJourneyBaseUrl + leadServiceApi + "Leads/searchlead",
};
export var QualityCheckUrl = {
    pendingTransactions: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "pendingtransactions",
    pendingTransactionById: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "pendingtransactionById",
    assignToSelf: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "assigntoself",
    updateApproveRejectStatus: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "updateapproverejectstatus",
    documentList: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "documentlist",
    documentDetails: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "documentdetails",
    modifyTransaction: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "modifytransaction",
    folioDetails: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "foliodetails",
    pendingCount: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "pendingcount",
    downloadPendingTransaction: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "downloadpendingtransactions",
    uploadDocs: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "uploaddocs",
    deleteDocs: config.investmentJourneyBaseUrl +
        investmentService +
        v3 +
        qc +
        "deletedocs",
};
export default AifPmsConfigURL;
